import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import { fetchSecretCode } from "../../api/fetch-secret-code";
import { TwoColumnLayout } from "../../templates";
import { QrCodeRenderer } from "./QrCodeRenderer";
import { SecretCodeRenderer } from "./SecretCodeRenderer";
import { SendUserCode } from "./SendUserCode";
import { MFAInstructions } from "./MFAInstructions";
import { notifyError } from "../../lib/notifications";

export const AssociateSoftwareToken = ({ email }) => {
  const [secretCode, setSecretCode] = useState(null);

  const history = useHistory();

  useEffect(() => {
    fetchSecretCode()
      .then((res) => {
        setSecretCode(res.data.secret_code);
      })
      .catch((error) => {
        if (!error.response) {
          return notifyError("Network error");
        }

        if (error.response.status === 401) {
          notifyError("Access token expired");
          return history.push("/login");
        }

        return notifyError("Something went wrong");
      });
    // eslint-disable-next-line
  }, []);

  const leftContent = (
    <>
      <div className="flex gap-2 items-center mb-10">
        <img
          src="/design/images/login-page/breathe-logo-icon.svg"
          alt="Breathe logo icon"
          className="h-8 w-9"
        />
      </div>
      <div className="flex-1 flex flex-col items-center justify-center w-full">
        <img
          src="/design/images/login-page/two-fa-illustration.svg"
          alt="MFA setup illustration"
          className="h-auto max-h-[360px]"
          style={{ maxWidth: "86%" }}
        />
      </div>
    </>
  );

  return (
    <TwoColumnLayout leftContent={leftContent} contentMaxWidth={640}>
      <div className="flex flex-col gap-6 items-center w-full max-w-[374px] mx-auto">
        <MFAInstructions />
        {secretCode && (
          <>
            <SecretCodeRenderer secretCode={secretCode} />
            <QrCodeRenderer email={email} secretCode={secretCode} />
            <SendUserCode />
          </>
        )}
      </div>
    </TwoColumnLayout>
  );
};

AssociateSoftwareToken.propTypes = {
  email: PropTypes.string.isRequired,
};
